import styles from "../styles/Footer.module.css";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
// logo / icons
import footerLogo from "../images/footer/footerLogo.webp";
import { IoCall } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";
import { AiFillMessage } from "react-icons/ai";
import facebook from "../images/footer/facebook.webp";
import whatsapp from "../images/footer/whatsapp.webp";
import { MdWorkHistory, MdWarningAmber } from "react-icons/md";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          {/* About Section */}
          <div className={styles.footerAbout}>
            <img
              alt="Profixer Door Services Logo"
              src={footerLogo}
              className={styles.logo}
            />
            <p className={styles.aboutText}>
              Profixer Door Services is a trusted garage door repair and
              installation company serving Calgary and surrounding areas. We
              specialize in spring replacement, opener installation, cable
              repairs, remote setup, and full garage door
              installation/replacements. Known for fast response and fair
              pricing, we're proud to offer same-day service, honest advice, and
              quality workmanship.
            </p>
          </div>

          {/* Contact Section */}
          <div className={styles.footerSection}>
            <h3 className={styles.sectionTitle}>Contact</h3>
            <ul className={styles.contactList}>
              <li>
                <a
                  href="mailto:Service@profixer247.ca"
                  className={styles.contactLink}
                >
                  <IoMdMail className={styles.contactIcon} />
                  <span>Service@profixer247.ca</span>
                </a>
              </li>
              <li>
                <a href="tel:+14036907147" className={styles.contactLink}>
                  <IoCall className={styles.contactIcon} />
                  <span>(403) 690-7147</span>
                </a>
              </li>
              <li>
                <div className={styles.contactItem}>
                  <MdWorkHistory className={styles.contactIcon} />
                  <span>Every Day 7 a.m. - 11 p.m.</span>
                </div>
              </li>
              <li>
                <div className={styles.contactItem}>
                  <MdWarningAmber className={styles.contactIcon} />
                  <span>24/7 Emergency</span>
                </div>
              </li>
            </ul>

            <div className={styles.socialIcons}>
              <a
                href="https://www.facebook.com/profile.php?id=61577330197696"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
                aria-label="Visit us on Facebook"
              >
                <img
                  loading="lazy"
                  src={facebook}
                  alt="Facebook"
                  className={styles.socialImg}
                />
              </a>
              <a
                href="https://wa.me/+14036907147"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
                aria-label="Chat with us on WhatsApp"
              >
                <img
                  loading="lazy"
                  src={whatsapp}
                  alt="WhatsApp"
                  className={styles.socialImg}
                />
              </a>
              <a
                href="sms:+14036907147"
                className={`${styles.socialLink} ${styles.socialButton}`}
                aria-label="Send us a message"
              >
                <AiFillMessage />
              </a>
              <a
                href="tel:+14036907147"
                className={`${styles.socialLink} ${styles.socialButton}`}
                aria-label="Call us"
              >
                <IoCall />
              </a>
            </div>
          </div>

          {/* Services Section */}
          <div className={styles.footerSection}>
            <h3 className={styles.sectionTitle}>Our Services</h3>
            <ul className={styles.linkList}>
              <li>
                <Link
                  to="/spring-repair"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Spring Repair
                </Link>
              </li>
              <li>
                <Link
                  to="/cable-track"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Cable & Track Repair
                </Link>
              </li>
              <li>
                <Link
                  to="/roller-hinge"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Roller, Hinge & Bracket
                </Link>
              </li>
              <li>
                <Link
                  to="/panel-door"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Panel & Door Repair
                </Link>
              </li>
              <li>
                <Link
                  to="/opener-services"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Opener Services
                </Link>
              </li>
              <li>
                <Link
                  to="/control-access"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Control & Access
                </Link>
              </li>
              <li>
                <Link
                  to="/sensor-electrical"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Sensor & Electrical
                </Link>
              </li>
              <li>
                <Link
                  to="/garage-door-installation"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Installation
                </Link>
              </li>
              <li>
                <Link
                  to="/emergency-repairs"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  Emergency Repairs
                </Link>
              </li>
            </ul>
          </div>

          {/* Menu Section */}
          <div className={styles.footerSection}>
            <h3 className={styles.sectionTitle}>Menu</h3>
            <ul className={styles.linkList}>
              <li>
                <HashLink to="/#top" className={styles.footerLink}>
                  Home
                </HashLink>
              </li>
              <li>
                <HashLink to="/#services" className={styles.footerLink}>
                  Services
                </HashLink>
              </li>
              <li>
                <HashLink to="/#operation" className={styles.footerLink}>
                  Operation Area
                </HashLink>
              </li>
              <li>
                <HashLink to="/#gallery" className={styles.footerLink}>
                  Gallery
                </HashLink>
              </li>
              <li>
                <Link
                  to="/how-to-choose"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className={styles.footerLink}
                >
                  How to Choose a Door
                </Link>
              </li>
              <li>
                <HashLink to="/#about" className={styles.footerLink}>
                  About
                </HashLink>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className={styles.footerBottom}>
          <div className={styles.divider}></div>
          <p className={styles.copyright}>
            Copyright © 2025 All rights reserved to Profixer Door Services
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
